/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
import React from 'react';

import * as analytics from 'analytics/Analytics';
import DataConnector from 'connect/DataConnector';
import {ANALYTICS_MODULE} from 'constants/AnalyticsConstants';
import FeatureLibraryModal from 'molbio/feature-libraries/FeatureLibraryModal';
import ProteinActions from 'molbio/proteins/ProteinActions';
import ProteinAnnotationEditorActions from 'molbio/proteins/ProteinAnnotationEditorActions';
import ProteinStore from 'molbio/proteins/ProteinStore';
import {Protein} from 'molbio/proteins/util/ProteinConstants';
import EntityStore from 'stores/EntityStore';
import getTestProps from 'test/lib/cypress/getTestProps';
import Col from 'ui-library/bs/Col';
import Row from 'ui-library/bs/Row';
import runModal from 'ui-library/runModal';

import ProteinAnnotationEditor from './ProteinAnnotationEditor';
import ProteinAnnotationTable from './ProteinAnnotationsTable';

class ProteinAnnotationsPanelConnector extends DataConnector<Props, EnhancedProps> {
  props: any;
  proteinStore: any;
  shouldSubscribeToRedux = false;
  stores = [ProteinStore];

  enhanceProps(): EnhancedProps {
    const {proteinId} = this.props;
    return {
      protein: this.proteinStore().getProteinById(proteinId),
      selectedAnnotationId: this.proteinStore().getSelectedAnnotationId(proteinId),
      hoverAnnotationId: this.proteinStore().getHoveredAnnotationId(proteinId),
      editorData: this.proteinStore().getAnnotationEditorData(proteinId),
    };
  }
}

interface Props {
  proteinId: string;
}
interface EnhancedProps {
  protein: Protein;
  selectedAnnotationId?: string;
  hoverAnnotationId?: string;
  editorData?: any;
}

class ProteinAnnotationsPanel extends React.Component<Props & EnhancedProps> {
  _handleNewAnnotation = (): void => {
    analytics.track('protein', 'new_annotation_click', {
      product: ANALYTICS_MODULE.MOLBIO,
      protein_id: this.props.proteinId,
    });
    ProteinAnnotationEditorActions.newAnnotation(this.props.proteinId);
  };

  _handleAutoAnnotate = async (): Promise<void> => {
    analytics.track('protein', 'clicked_auto_annotate', {
      product: ANALYTICS_MODULE.MOLBIO,
      protein_id: this.props.proteinId,
    });
    const featureLibraryIds = await runModal(FeatureLibraryModal, {});
    analytics.track('protein', 'add_auto_annotations_click', {
      product: ANALYTICS_MODULE.MOLBIO,
      protein_id: this.props.proteinId,
      featureLibraryIds,
    });
    if (featureLibraryIds == null) {
      return;
    }

    ProteinActions.autoAnnotate(this.props.proteinId, featureLibraryIds);
  };

  render(): JSX.Element {
    const {protein, selectedAnnotationId, hoverAnnotationId, editorData} = this.props;
    const currentUser = EntityStore.currentUser();
    const featureLibraryUrl = currentUser && `/${currentUser.url_identifier}/feature-libraries/`;
    const allowFeatureEdits =
      protein.permissions && protein.permissions.polymerFeaturesEditable && protein.isLatest;

    return (
      <div
        className="proteinAnnotationsPanel"
        {...getTestProps({component: 'ProteinAnnotationPanel', element: 'root'})}
      >
        {allowFeatureEdits && (
          <div className="proteinAnnotationsPanel-newAnnotation u-small-spacing-bottom">
            <a onClick={this._handleNewAnnotation}>New annotation</a>
          </div>
        )}
        <ProteinAnnotationTable
          protein={protein}
          selectedAnnotationId={selectedAnnotationId}
          hoverAnnotationId={hoverAnnotationId}
        />
        {allowFeatureEdits &&
          editorData && [
            <div key="divider" className="panel-divider" />,
            <ProteinAnnotationEditor
              key="editor"
              proteinId={protein.id}
              name={editorData.name}
              type={editorData.type}
              notes={editorData.notes}
              displayStart={editorData.displayStart}
              displayEnd={editorData.displayEnd}
              color={editorData.color}
              pendingEditorFocus={editorData.pendingEditorFocus}
              isInputValid={editorData.isInputValid}
              isAnnotationSelected={selectedAnnotationId != null}
            />,
          ]}
        {allowFeatureEdits && [
          <div key="divider" className="panel-divider" />,
          <Row key="row">
            <Col md={6}>
              <button
                className="button button--secondary button--small proteinAnnotationsPanel-autoAnnotate"
                onClick={this._handleAutoAnnotate}
                type="button"
              >
                Auto-annotate
              </button>
            </Col>
            <Col md={6}>
              {featureLibraryUrl && (
                <div className="proteinAnnotationsPanel-editFeatureLibraries">
                  <a href={featureLibraryUrl} target="_blank" rel="noopener noreferrer">
                    Edit Feature Libraries
                  </a>
                </div>
              )}
            </Col>
          </Row>,
        ]}
      </div>
    );
  }
}

export default ProteinAnnotationsPanelConnector.connect(ProteinAnnotationsPanel);
